export default "__VITE_ASSET__BGBze6nI__"